module.exports = __webpack_public_path__ + "img/stack.196b2afa.svg";